module.exports = __webpack_public_path__ + "static/img/ico_logo.4162a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/ico_logo.png
// module id = 10C5
// module chunks = 0